import { render } from "./HorizontalCarousel.vue?vue&type=template&id=26e42836"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__